import { useMemo, useState } from 'react'
import { formatMoney } from '../../lib/format.js'
import BreakdownShell, { SortHeader, useSortedUnits } from './BreakdownShell.jsx'

// WasteBreakdownTable — by-unit 14-day waste cost + log count.
// Footer totals equal the headline KPI by construction.

export default function WasteBreakdownTable({ perUnit, onBack }) {
  // --- All hooks BEFORE any conditional return (React #310). ---
  const [sortKey, setSortKey] = useState('waste_14d_cost')
  const [sortDir, setSortDir] = useState('desc')
  const rows = useSortedUnits(perUnit, sortKey, sortDir)

  const { totalCost, totalCount } = useMemo(() => {
    let cost = 0, count = 0
    for (const r of rows) {
      cost += Number(r.waste_14d_cost) || 0
      count += Number(r.waste_14d_count) || 0
    }
    return { totalCost: cost, totalCount: count }
  }, [rows])

  function toggle(key) {
    if (key === sortKey) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'))
    else { setSortKey(key); setSortDir('desc') }
  }

  return (
    <BreakdownShell title="14-day waste by location" onBack={onBack}>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-black/10 text-left text-[11px] uppercase tracking-wide text-black/55">
            <SortHeader label="Location" k="name" sortKey={sortKey} sortDir={sortDir} onClick={toggle} />
            <SortHeader label="Waste cost" k="waste_14d_cost" sortKey={sortKey} sortDir={sortDir} onClick={toggle} align="right" />
            <SortHeader label="Items logged" k="waste_14d_count" sortKey={sortKey} sortDir={sortDir} onClick={toggle} align="right" />
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-b border-black/5 last:border-b-0">
              <td className="py-2.5 pr-3 font-medium text-black/85">{r.name}</td>
              <td className="py-2.5 pl-3 text-right tabular-nums text-black/85">{formatMoney(r.waste_14d_cost)}</td>
              <td className="py-2.5 pl-3 text-right tabular-nums text-black/85">{Number(r.waste_14d_count) || 0}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t-2 border-black/15 font-semibold">
            <td className="py-2.5 pr-3 text-black/85">All units</td>
            <td className="py-2.5 pl-3 text-right tabular-nums text-black/85">{formatMoney(totalCost)}</td>
            <td className="py-2.5 pl-3 text-right tabular-nums text-black/85">{totalCount}</td>
          </tr>
        </tfoot>
      </table>
    </BreakdownShell>
  )
}
